import React from "react";
import { Row, Col } from "antd";

const Footer = () => {
  return (
    <footer className="footer" style={{ padding: "20px 24px" }}>
      <Row>
        <Col xs={24}>
          <div className="text-center text-sm-end d-block d-sm-none">
            {new Date().getFullYear()} © CodeLaksh.
          </div>
          <div className="text-sm-end d-none d-sm-block">
            {new Date().getFullYear()} © CodeLaksh.
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
